import { defineMessages, IntlShape } from "react-intl";

enum ResourceContentType {
  DOCUMENT = "document",
  SPREADSHEET = "spreadsheet",
  PRESENTATION = "presentation",
  IMAGE = "image",
  PDF = "pdf",
  VIDEO = "video",
  ARCHIVE = "archive",
  AUDIO = "audio",
  LINK = "link",
}

const messages = defineMessages<ResourceContentType>({
  [ResourceContentType.ARCHIVE]: {
    id: "component.resourcescontent.type.archive",
    defaultMessage: "Archives (zip)",
    description: "Archives (zip) resource type",
  },
  [ResourceContentType.AUDIO]: {
    id: "component.resourcescontent.type.audio",
    defaultMessage: "Audio",
    description: "Audio resource type",
  },
  [ResourceContentType.DOCUMENT]: {
    id: "component.resourcescontent.type.document",
    defaultMessage: "Documents",
    description: "Documents resource type",
  },
  [ResourceContentType.IMAGE]: {
    id: "component.resourcescontent.type.image",
    defaultMessage: "Photos & Images",
    description: "Photos resource type",
  },
  [ResourceContentType.LINK]: {
    id: "component.resourcescontent.type.link",
    defaultMessage: "Links / URLs",
    description: "Links resource type",
  },
  [ResourceContentType.PDF]: {
    id: "component.resourcescontent.type.pdf",
    defaultMessage: "PDFs",
    description: "PDFs resource type",
  },
  [ResourceContentType.PRESENTATION]: {
    id: "component.resourcescontent.type.presentation",
    defaultMessage: "Presentations",
    description: "Presentations resource type",
  },
  [ResourceContentType.SPREADSHEET]: {
    id: "component.resourcescontent.type.spreadsheet",
    defaultMessage: "Spreadsheets",
    description: "Spreadsheets resource type",
  },
  [ResourceContentType.VIDEO]: {
    id: "component.resourcescontent.type.video",
    defaultMessage: "Videos",
    description: "Videos resource type",
  },
});

export const getResourceContentTypeName = (intl: IntlShape, type: ResourceContentType) =>
  intl.formatMessage(messages[type]);

export default ResourceContentType;
